<template>
  <teleport to="body">
    <div v-if="openDelModal" class="modal">
      <div class="wrapper">
        <font-awesome-icon icon="xmark" class="exit" @click="closeModal()" />
        <h2>Delivery</h2>
        <h4>Check if you are elegible for delivery</h4>
        <div class="form">
          <label for="delAddress">Address:</label>
          <input type="text" autocomplete="off" id="search" v-model="searchAddress" placeholder="Start typing your address..." />
        </div>
        <div v-if="searching" class="results">
          <p v-for="address in getAddressLookup" class="address" :key="address" @click.stop.prevent="checkAddress(address)">{{ address[2] }}</p>
        </div>
        <div v-if="selectedAddress" class="selectedAddress">
          <p>{{ getDeliveryAddress }}</p>
        </div>
        <div v-if="responseMsg" class="response">
          <p>{{ responseMsg.msg }}</p>
          <button v-if="responseMsg.value == true" @click.stop.prevent="closeModal">Start Order</button>
          <button v-if="responseMsg.value == false" @click.stop.prevent="closeModal">Close</button>
        </div>
        <div v-if="errors" class="error">
          <p>{{ errors }}</p>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DeliveryModal",
  data() {
    return {
      searchAddress: "",
      errors: "",
      responseMsg: {},
      selectedAddress: "",
      searching: false,
    };
  },
  emits: ["closeDeliveryModal"],

  props: {
    openDelModal: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      siteSettings: "siteSettings",
      getAddressLookup: "getAddressLookup",
      getDeliveryAddress: "getDeliveryAddress",
    }),
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Backspace") {
        this.resetSearch();
      }
    });
  },

  unmounted() {
    document.removeEventListener("keydown", this.resetSearch);
  },

  methods: {
    resetSearch() {
      this.responseMsg = {};
      this.errors = "";
      this.selectedAddress = "";
      this.searching = true;
    },

    closeModal() {
      this.$emit("closeDeliveryModal");
    },

    async getAddress() {
      const url = encodeURI(`https://geo.beamy.nz/api/address/search/${this.searchAddress}`);
      const response = await fetch(url);
      this.$store.dispatch("setAddressLookup", await response.json());
    },

    async checkAddress(address) {
      this.selectedAddress = address;
      this.searching = false;
      let polygon = { type: "Polygon", coordinates: [this.siteSettings.delivery_polygon] };
      let addresCoordinates = { type: "Point", coordinates: [parseFloat(address[1]), parseFloat(address[0])] };
      let postMsg = {
        polygon: polygon,
        address: addresCoordinates,
      };
      let url = "https://geo.beamy.nz/api/delivery/available";
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postMsg),
      });
      this.handleResponse(response);
    },

    async handleResponse(response) {
      if (response.status !== 200) {
        this.errors = "Error: " + response.status;
        return;
      }
      let data = await response.json();
      if (data.contains == true) {
        this.$store.dispatch("setDeliveryAddress", this.selectedAddress);
        this.responseMsg = {
          msg: "Great news, bagels to your door! Select delivery at checkout",
          value: data.contains,
        };
      } else {
        this.responseMsg = {
          msg: "Sorry, delivery is not available to this address at this stage",
          value: data.contains,
        };
      }
    },
  },
  watch: {
    searchAddress() {
      if (this.searchAddress.length > 3) {
        this.getAddress();
        this.searching = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "public/layout";
@import "public/actions";
@import "public/wrapper";
@import "public/search";
.modal {
  text-align: center;
  h4 {
    margin: 0 1rem;
  }
  .results {
    .address {
      padding: 1rem;
      margin: 0.5rem;
      border-radius: 5px;
      background-color: var(--primary-colour);
      cursor: pointer;
    }
  }
  .form {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    width: 90%;
    padding: 1rem;
    border-radius: 5px;
    small {
      color: var(--action-colour);
    }
    input {
      margin: 0.25rem 0;
      padding: 0.75rem;
      border-radius: 5px;
      border: 1px solid #ccc;
    }
  }
}
</style>
